function setAgreeDBPRTerms({ state }) {
  const user = state.get('client.user')
  const acceptedGDPR = user.agreedGDPRTermsAt ? true : false
  state.set('login.acceptedGDPR', acceptedGDPR) // is a date and can be null
  if (!acceptedGDPR) {
    state.set('login.showGDPRDialog', true)
  }
}

export default setAgreeDBPRTerms



// WEBPACK FOOTER //
// ./src/modules/app/actions/setAgreeDBPRTerms.js